import React, {useEffect, useState} from 'react';
import {EmptyTopBar, Loading} from '../../components';
import {Box} from '@material-ui/core';
import useStyles from './RegisterMojeIDPageStyles';
import i18nNamespaces from '../../const/i18nNamespaces';
import {useTranslation} from 'react-i18next';
import EntraIDRegisterForm, {
    EntraIDRegisterFormValues,
} from '../../components/forms/EntraIDRegisterForm/EntraIDRegisterForm';
import {useAppDispatch, useAppSelector} from '../../hooks/customReduxHooks';
import {
    selectAuthEmail,
    selectAuthError,
    selectAuthStatus,
    signUpRegisterEntraId,
} from '../../store/auth';
import useMsalActiveAccount from '../../hooks/msal/useMsalActiveAccount';
import {PHONE_VERIFICATION_PAGE} from '../../const/routes';
import {useHistory} from 'react-router';
import useQuery from '../../hooks/useQuery';
import RegisterPhoneNumberForm, {
    RegisterPhoneNumberFormValues
} from "../../components/forms/RegisterPhoneNumberForm/RegisterPhoneNumberForm";
import Footer from "../../components/Layout/Footer/Footer";
import {microsoftAuthService} from "../../services/microsoftAuthService";

const RegisterEntraIDPage = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const classes = useStyles();
    const {t} = useTranslation(i18nNamespaces.AUTH);
    const singUpError = useAppSelector(selectAuthError);
    const {activeAccount, getIdToken} = useMsalActiveAccount();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const query = useQuery();
    const returnUrl = query.get('returnUrl');
    const encodedReturnUrl = '?returnUrl=' + encodeURIComponent(returnUrl);
    const status = useAppSelector(selectAuthStatus);
    const authEmail = useAppSelector(selectAuthEmail);

    useEffect(() => {
        if (status === 'loaded') {
            if (returnUrl) {
                history.push({
                    pathname: PHONE_VERIFICATION_PAGE,
                    state: {email: authEmail},
                    search: encodedReturnUrl,
                });
            } else {
                history.push({
                    pathname: PHONE_VERIFICATION_PAGE,
                    state: {email: authEmail},
                });
            }
        }
    }, [status, returnUrl]);

    const submitHandler = async (
        registrationData: RegisterPhoneNumberFormValues,
    ) => {
        setLoading(true);
        await dispatch(
            signUpRegisterEntraId({
                registrationData,
                activeAccount: {...activeAccount, idToken: await getIdToken()},
            }),
        );
        if (status === 'loaded') {
            history.push({
                pathname: PHONE_VERIFICATION_PAGE,
                state: {email: activeAccount.username},
            });
        }
        setLoading(false);
    };

    const handleClose = async () => {
        await microsoftAuthService.silentLogout();
        history.push('/');
    }

    return (
        <>
            <EmptyTopBar onCancel={handleClose}/>
            <Loading loading={loading || status === 'loading'} withBackdrop />
            <Box className={classes.container}>
                <Box className={classes.header}>
                    {t('enterRegistrationData')}
                </Box>
                {activeAccount && (
                    <Box>
                        <Box>
                            {t('user')}: {activeAccount.username}
                        </Box>
                    </Box>
                )}
                <RegisterPhoneNumberForm
                    onSubmit={submitHandler}
                    error={singUpError}
                />
            </Box>
            <Footer />
        </>
    );
};

export default RegisterEntraIDPage;
